import { mock } from './';

export function fetchStateMock() {
  return mock({
    error: false,
    message: 'FETCH_STATE_ERROR',
    stage: 2,
  });
}
